import React, { useRef } from "react";
import { SDrawerOrModal, SLowcodeList, SMessage, STags } from "shj-components";

import { getConfig } from './config.jsx'
import { useSetState } from "ahooks";
import { message, Switch } from "antd";
import { batchUpdateProductSkuEnabled, getCombinationSkuList, getProductSkuSelectList } from "@/services/product.ts";
import { apiData2Table } from "@/utils/data.ts";

const SKUDetailsModal = (props) => {
  const { open, onClose, spuData = {}, isEdit = false } = props;
  const listRef = useRef();
  const [state, setState] = useSetState({
    selectedRowKeys: [],
  })

  const fetchList = ({ query }) => {
    const productId = spuData.id
    if (!productId) return Promise.reject()
    return new Promise((resolve, reject) => {
      isEdit ? getProductSkuSelectList({
          productId,
          queryShops: true,
          ...query
        })
          .then(res => {
            resolve({ records: res })
          }).catch(err => {
            reject(err)
          })
        : getCombinationSkuList(productId, {
          data: {
            queryShops: true,
            ...query,
          },
          params: {
            pageId: 1,
            pageSize: 9999,
          }
        }).then(res => {
          resolve(apiData2Table(res))
        }).catch(err => {
          reject(err)
        })
    })
  }

  const onChangeStatus = (checked, id) => {
    if (!id) return;
    SMessage.confirm({
      title: `是否确定${checked ? '启用' : '禁用'}当前数据？`,
      content: null,
      onOk: () => {
        const params = {
          skuQuery: { ids: [id] },
          enabled: checked
        }
        batchUpdateProductSkuEnabled(params).then(res => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      }
    })
  }

  const extension = {
    request: { fetchList },
    rowKey: 'id',
    rowSelection: {
      selectedRowKeys: state.selectedRowKeys,
      onChange: (selectedRowKeys) => {
        setState({ selectedRowKeys })
      },
    },
    customRender: {
      nameRender(v) {
        return <div style={{ maxWidth: 200, whiteSpace: 'wrap', wordBreak: 'break-all' }}>{v}</div>
      },
      shopNameRender(v) {
        const names = v?.map?.(item => item.companyName)
        return names?.join?.(', ')
      },
      enabledRender(v, record) {
        return isEdit ? <Switch
            checked={v}
            onClick={checked => onChangeStatus(checked, record.id)}
            checkedChildren={'启用'}
            unCheckedChildren={'禁用'}
          />
          : <STags
            itemKey=""
            label={v ? '启用' : '禁用'}
            fontColor={v ? '#00A865' : '#EB3723'}
            bgColor={v ? '#D7F7EA' : '#FFEAE8'}
          />
      },
    }
  }

  return <>
    <SDrawerOrModal
      title={props.title || 'SKU明细'}
      width={900}
      open={open}
      loading={false}
      onCancel={onClose}
      antdProps={{
        footer: null
      }}
    >
      <SLowcodeList searchMode={'group'} ref={listRef} config={getConfig(isEdit)} {...extension}/>
    </SDrawerOrModal>
  </>
}

export default SKUDetailsModal